import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectProcessingUpdateType } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { DataObjectProcessingUpdatesSchema } from '../schema/DataObjectProcessingUpdatesSchema';

const getInputDataRefreshAggregates = (ids?: number[], dataManager?: string) =>
  apiClient
    .get<
      Array<DataObjectProcessingUpdateType>
    >(expand(InputDataUrl.INPUT_DATA_GROUP_PROCESSING_STATES_REFRESH, { ids, dataManager }))
    .then((response) => DataObjectProcessingUpdatesSchema.parse(response.data));

const queryKey = ['inputDataRefreshAggregates'] as const;

export const useInputDataGroupProcessingStateRefreshQuery = createApiQueryHook(
  queryKey,
  getInputDataRefreshAggregates,
);

export const useRemoveInputDataAggregateRefreshQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.removeQueries({
        queryKey,
        exact: false,
      }),
    [queryClient],
  );
};
